// !!!!!!!!!!! WARNING: DO NOT EDIT THIS FILE DIRECTLY !!!!!!!!!!!
// This file is generated using `bundle exec rake compile_locales`
/* eslint-disable camelcase, no-useless-escape, prettier/prettier */
import i18n from "utils/i18n";
import moment from "moment";

i18n.locale = "en";
moment.locale("en");

i18n.paths = {
  billing_coupon: "/%{locale}/billing/coupon",
  board_statuses: "/%{locale}/board/statuses",
  board_user: "/%{locale}/board/users/%{id}",
  counts_reports_filter: "/%{locale}/reports/filters/%{id}/counts",
  create_badges_manager_badges: "/%{locale}/manager/badges/create_badges",
  destroy_all_manager_badges: "/%{locale}/manager/badges/destroy_all",
  edit_manager_beacon: "/%{locale}/manager/beacons/%{id}/edit",
  edit_manager_bulk_beacon: "/%{locale}/manager/bulk/beacons/%{id}/edit",
  edit_manager_bulk_fence: "/%{locale}/manager/bulk/fences/%{id}/edit",
  edit_manager_bulk_hook: "/%{locale}/manager/bulk/hooks/%{id}/edit",
  edit_manager_bulk_network: "/%{locale}/manager/bulk/networks/%{id}/edit",
  edit_manager_bulk_reset: "/%{locale}/manager/bulk/resets/%{id}/edit",
  edit_manager_company: "/%{locale}/manager/company/edit",
  edit_manager_fence: "/%{locale}/manager/fences/%{id}/edit",
  edit_manager_integrations_hook: "/%{locale}/manager/integrations/hooks/%{id}/edit",
  edit_manager_network: "/%{locale}/manager/networks/%{id}/edit",
  edit_manager_reset: "/%{locale}/manager/resets/%{id}/edit",
  edit_manager_user: "/%{locale}/manager/users/%{id}/edit",
  feature: "/%{locale}/features/%{id}",
  mailing_list_subscription: "/%{locale}/mailing_list_subscriptions/%{id}",
  mailing_list_subscriptions: "/%{locale}/mailing_list_subscriptions",
  manager_bulk_beacon: "/%{locale}/manager/bulk/beacons/%{id}",
  manager_bulk_fence: "/%{locale}/manager/bulk/fences/%{id}",
  manager_bulk_hook: "/%{locale}/manager/bulk/hooks/%{id}",
  manager_bulk_network: "/%{locale}/manager/bulk/networks/%{id}",
  manager_bulk_reset: "/%{locale}/manager/bulk/resets/%{id}",
  manager_role: "/%{locale}/manager/roles/%{id}",
  manager_subscription: "/%{locale}/manager/subscription",
  new_manager_beacon: "/%{locale}/manager/beacons/new",
  new_manager_fence: "/%{locale}/manager/fences/new",
  new_manager_integrations_hook: "/%{locale}/manager/integrations/hooks/new",
  new_manager_network: "/%{locale}/manager/networks/new",
  new_manager_reset: "/%{locale}/manager/resets/new",
  plan_save_card: "/%{locale}/plans/save_card",
  reports_activity: "/%{locale}/reports/activity",
  reports_contacts: "/%{locale}/reports/contacts",
  reports_daily_timeline: "/%{locale}/reports/daily_timeline",
  reports_export: "/%{locale}/reports/export",
  reports_filter: "/%{locale}/reports/filters/%{id}",
  reports_filters: "/%{locale}/reports/filters",
  reports_pdf: "/%{locale}/reports/pdf",
  reports_time_card: "/%{locale}/reports/time_card",
  reports_weekly_timeline: "/%{locale}/reports/weekly_timeline",
  time_card_reports_user: "/%{locale}/reports/users/%{id}/time_card",
  time_line_reports_user: "/%{locale}/reports/users/%{id}/time_line",
  upsert_manager_badges: "/%{locale}/manager/badges/upsert"
};

i18n.timeZones = {
  other: [
    ["Etc/GMT+12", "(GMT-12:00) International Date Line West"],
    ["Pacific/Pago_Pago", "(GMT-11:00) American Samoa"],
    ["Pacific/Midway", "(GMT-11:00) Midway Island"],
    ["America/Tijuana", "(GMT-08:00) Tijuana"],
    ["America/Chihuahua", "(GMT-07:00) Chihuahua"],
    ["America/Mazatlan", "(GMT-07:00) Mazatlan"],
    ["America/Guatemala", "(GMT-06:00) Central America"],
    ["America/Mexico_City", "(GMT-06:00) Mexico City"],
    ["America/Monterrey", "(GMT-06:00) Monterrey"],
    ["America/Regina", "(GMT-06:00) Saskatchewan"],
    ["America/Bogota", "(GMT-05:00) Bogota"],
    ["America/Lima", "(GMT-05:00) Lima"],
    ["America/Halifax", "(GMT-04:00) Atlantic Time (Canada)"],
    ["America/Caracas", "(GMT-04:00) Caracas"],
    ["America/Guyana", "(GMT-04:00) Georgetown"],
    ["America/La_Paz", "(GMT-04:00) La Paz"],
    ["America/Puerto_Rico", "(GMT-04:00) Puerto Rico"],
    ["America/Santiago", "(GMT-04:00) Santiago"],
    ["America/St_Johns", "(GMT-03:30) Newfoundland"],
    ["America/Sao_Paulo", "(GMT-03:00) Brasilia"],
    ["America/Argentina/Buenos_Aires", "(GMT-03:00) Buenos Aires"],
    ["America/Godthab", "(GMT-03:00) Greenland"],
    ["America/Montevideo", "(GMT-03:00) Montevideo"],
    ["Atlantic/South_Georgia", "(GMT-02:00) Mid-Atlantic"],
    ["Atlantic/Azores", "(GMT-01:00) Azores"],
    ["Atlantic/Cape_Verde", "(GMT-01:00) Cape Verde Is."],
    ["Africa/Casablanca", "(GMT+00:00) Casablanca"],
    ["Europe/Dublin", "(GMT+00:00) Dublin"],
    ["Europe/Lisbon", "(GMT+00:00) Lisbon"],
    ["Europe/London", "(GMT+00:00) London"],
    ["Africa/Monrovia", "(GMT+00:00) Monrovia"],
    ["Etc/UTC", "(GMT+00:00) UTC"],
    ["Europe/Amsterdam", "(GMT+01:00) Amsterdam"],
    ["Europe/Belgrade", "(GMT+01:00) Belgrade"],
    ["Europe/Berlin", "(GMT+01:00) Berlin"],
    ["Europe/Bratislava", "(GMT+01:00) Bratislava"],
    ["Europe/Brussels", "(GMT+01:00) Brussels"],
    ["Europe/Budapest", "(GMT+01:00) Budapest"],
    ["Europe/Copenhagen", "(GMT+01:00) Copenhagen"],
    ["Europe/Ljubljana", "(GMT+01:00) Ljubljana"],
    ["Europe/Madrid", "(GMT+01:00) Madrid"],
    ["Europe/Paris", "(GMT+01:00) Paris"],
    ["Europe/Prague", "(GMT+01:00) Prague"],
    ["Europe/Rome", "(GMT+01:00) Rome"],
    ["Europe/Sarajevo", "(GMT+01:00) Sarajevo"],
    ["Europe/Skopje", "(GMT+01:00) Skopje"],
    ["Europe/Stockholm", "(GMT+01:00) Stockholm"],
    ["Europe/Vienna", "(GMT+01:00) Vienna"],
    ["Europe/Warsaw", "(GMT+01:00) Warsaw"],
    ["Africa/Algiers", "(GMT+01:00) West Central Africa"],
    ["Europe/Zagreb", "(GMT+01:00) Zagreb"],
    ["Europe/Zurich", "(GMT+01:00) Zurich"],
    ["Europe/Athens", "(GMT+02:00) Athens"],
    ["Europe/Bucharest", "(GMT+02:00) Bucharest"],
    ["Africa/Cairo", "(GMT+02:00) Cairo"],
    ["Africa/Harare", "(GMT+02:00) Harare"],
    ["Europe/Helsinki", "(GMT+02:00) Helsinki"],
    ["Asia/Jerusalem", "(GMT+02:00) Jerusalem"],
    ["Europe/Kaliningrad", "(GMT+02:00) Kaliningrad"],
    ["Europe/Kiev", "(GMT+02:00) Kyiv"],
    ["Africa/Johannesburg", "(GMT+02:00) Pretoria"],
    ["Europe/Riga", "(GMT+02:00) Riga"],
    ["Europe/Sofia", "(GMT+02:00) Sofia"],
    ["Europe/Tallinn", "(GMT+02:00) Tallinn"],
    ["Europe/Vilnius", "(GMT+02:00) Vilnius"],
    ["Asia/Baghdad", "(GMT+03:00) Baghdad"],
    ["Europe/Istanbul", "(GMT+03:00) Istanbul"],
    ["Asia/Kuwait", "(GMT+03:00) Kuwait"],
    ["Europe/Minsk", "(GMT+03:00) Minsk"],
    ["Europe/Moscow", "(GMT+03:00) Moscow"],
    ["Africa/Nairobi", "(GMT+03:00) Nairobi"],
    ["Asia/Riyadh", "(GMT+03:00) Riyadh"],
    ["Asia/Tehran", "(GMT+03:30) Tehran"],
    ["Asia/Baku", "(GMT+04:00) Baku"],
    ["Asia/Muscat", "(GMT+04:00) Muscat"],
    ["Europe/Samara", "(GMT+04:00) Samara"],
    ["Asia/Tbilisi", "(GMT+04:00) Tbilisi"],
    ["Europe/Volgograd", "(GMT+04:00) Volgograd"],
    ["Asia/Yerevan", "(GMT+04:00) Yerevan"],
    ["Asia/Kabul", "(GMT+04:30) Kabul"],
    ["Asia/Yekaterinburg", "(GMT+05:00) Ekaterinburg"],
    ["Asia/Karachi", "(GMT+05:00) Karachi"],
    ["Asia/Tashkent", "(GMT+05:00) Tashkent"],
    ["Asia/Kolkata", "(GMT+05:30) Kolkata"],
    ["Asia/Colombo", "(GMT+05:30) Sri Jayawardenepura"],
    ["Asia/Kathmandu", "(GMT+05:45) Kathmandu"],
    ["Asia/Almaty", "(GMT+06:00) Almaty"],
    ["Asia/Dhaka", "(GMT+06:00) Dhaka"],
    ["Asia/Urumqi", "(GMT+06:00) Urumqi"],
    ["Asia/Rangoon", "(GMT+06:30) Rangoon"],
    ["Asia/Bangkok", "(GMT+07:00) Bangkok"],
    ["Asia/Jakarta", "(GMT+07:00) Jakarta"],
    ["Asia/Krasnoyarsk", "(GMT+07:00) Krasnoyarsk"],
    ["Asia/Novosibirsk", "(GMT+07:00) Novosibirsk"],
    ["Asia/Shanghai", "(GMT+08:00) Beijing"],
    ["Asia/Chongqing", "(GMT+08:00) Chongqing"],
    ["Asia/Hong_Kong", "(GMT+08:00) Hong Kong"],
    ["Asia/Irkutsk", "(GMT+08:00) Irkutsk"],
    ["Asia/Kuala_Lumpur", "(GMT+08:00) Kuala Lumpur"],
    ["Australia/Perth", "(GMT+08:00) Perth"],
    ["Asia/Singapore", "(GMT+08:00) Singapore"],
    ["Asia/Taipei", "(GMT+08:00) Taipei"],
    ["Asia/Ulaanbaatar", "(GMT+08:00) Ulaanbaatar"],
    ["Asia/Seoul", "(GMT+09:00) Seoul"],
    ["Asia/Tokyo", "(GMT+09:00) Tokyo"],
    ["Asia/Yakutsk", "(GMT+09:00) Yakutsk"],
    ["Australia/Adelaide", "(GMT+09:30) Adelaide"],
    ["Australia/Darwin", "(GMT+09:30) Darwin"],
    ["Australia/Brisbane", "(GMT+10:00) Brisbane"],
    ["Pacific/Guam", "(GMT+10:00) Guam"],
    ["Australia/Hobart", "(GMT+10:00) Hobart"],
    ["Australia/Melbourne", "(GMT+10:00) Melbourne"],
    ["Pacific/Port_Moresby", "(GMT+10:00) Port Moresby"],
    ["Australia/Sydney", "(GMT+10:00) Sydney"],
    ["Asia/Vladivostok", "(GMT+10:00) Vladivostok"],
    ["Asia/Magadan", "(GMT+11:00) Magadan"],
    ["Pacific/Noumea", "(GMT+11:00) New Caledonia"],
    ["Pacific/Guadalcanal", "(GMT+11:00) Solomon Is."],
    ["Asia/Srednekolymsk", "(GMT+11:00) Srednekolymsk"],
    ["Pacific/Auckland", "(GMT+12:00) Auckland"],
    ["Pacific/Fiji", "(GMT+12:00) Fiji"],
    ["Asia/Kamchatka", "(GMT+12:00) Kamchatka"],
    ["Pacific/Majuro", "(GMT+12:00) Marshall Is."],
    ["Pacific/Chatham", "(GMT+12:45) Chatham Is."],
    ["Pacific/Tongatapu", "(GMT+13:00) Nuku\'alofa"],
    ["Pacific/Apia", "(GMT+13:00) Samoa"],
    ["Pacific/Fakaofo", "(GMT+13:00) Tokelau Is."]
  ],
  us: [
    ["Pacific/Honolulu", "(GMT-10:00) Hawaii"],
    ["America/Juneau", "(GMT-09:00) Alaska"],
    ["America/Los_Angeles", "(GMT-08:00) Pacific Time (US & Canada)"],
    ["America/Phoenix", "(GMT-07:00) Arizona"],
    ["America/Denver", "(GMT-07:00) Mountain Time (US & Canada)"],
    ["America/Chicago", "(GMT-06:00) Central Time (US & Canada)"],
    ["America/New_York", "(GMT-05:00) Eastern Time (US & Canada)"],
    ["America/Indiana/Indianapolis", "(GMT-05:00) Indiana (East)"]
  ]
};

i18n.translations = {
  "activerecord.attributes.beacon.uuid": "UUID",
  "activerecord.attributes.fence.radius": "Radius",
  "activerecord.attributes.hook.active": "Active",
  "activerecord.attributes.hook.status_destroy": "Destroyed Statuses",
  "activerecord.attributes.hook.status_new": "New Statuses",
  "activerecord.attributes.hook.status_scheduled": "Scheduled Statuses",
  "activerecord.attributes.hook.url": "URL",
  "activerecord.attributes.network.ssid": "SSID",
  "activerecord.attributes.public_link.time_visible": "Last Updated Time",
  "activerecord.attributes.reminder.status": "Status",
  "activerecord.attributes.reset.wdays": "Days of the Week",
  "activerecord.attributes.role.billing": "Manage billing details",
  "activerecord.attributes.role.followed_users": "Followed user notifications",
  "activerecord.attributes.role.manage_company_and_users": "Manage company settings",
  "activerecord.attributes.role.manage_groups_and_memberships": "Manage groups",
  "activerecord.attributes.role.manage_others_archives": "Manage the status history of others",
  "activerecord.attributes.role.manage_others_futures": "Manage the scheduled statuses of others",
  "activerecord.attributes.role.manage_others_status": "Manage the current statuses of others",
  "activerecord.attributes.role.manage_own_archives": "Manage your own status history",
  "activerecord.attributes.role.manage_own_futures": "Manage your own scheduled statuses",
  "activerecord.attributes.role.manage_own_status": "Manage your own current status",
  "activerecord.attributes.role.reminders": "Manage reminders",
  "activerecord.attributes.role.safeties": "Safety notifications",
  "activerecord.attributes.role.user_board": "View all users",
  "activerecord.attributes.role.view_others_archives": "View the status history of others",
  "activerecord.attributes.role.view_others_futures": "View the scheduled statuses of others",
  "activerecord.attributes.role.view_others_reports": "Run reports on others",
  "activerecord.attributes.role.view_user_board_updated_at": "View status update times",
  "activerecord.attributes.status.admin": "Changed By Admin",
  "activerecord.attributes.status.comment": "Comment",
  "activerecord.attributes.status.status": "Status",
  "activerecord.attributes.user.details": "Details",
  "activerecord.attributes.user.email": "Email",
  "activerecord.attributes.user.image_url": "Profile Image",
  "activerecord.attributes.user.name": "Name",
  "activerecord.errors.format": "%{attribute} %{message}",
  "activerecord.errors.messages.blank": "can\'t be blank",
  "activerecord.models.application.one": "Application",
  "activerecord.models.archive.other": "Past Statuses",
  "activerecord.models.beacon.one": "Beacon",
  "activerecord.models.company.one": "Company",
  "activerecord.models.document.other": "Documents",
  "activerecord.models.favorite.one": "Company Quick Pick",
  "activerecord.models.favorite.other": "Company Quick Picks",
  "activerecord.models.fence.one": "Geofence",
  "activerecord.models.future.one": "Scheduled Status",
  "activerecord.models.future.other": "Scheduled Statuses",
  "activerecord.models.group.one": "Group",
  "activerecord.models.group.other": "Groups",
  "activerecord.models.hook.one": "Web Hook",
  "activerecord.models.hook.other": "Web Hooks",
  "activerecord.models.network.one": "Network",
  "activerecord.models.phone.other": "Phones",
  "activerecord.models.public_link.one": "Public Link",
  "activerecord.models.reminder.one": "Reminder",
  "activerecord.models.reset.one": "Status Reset",
  "activerecord.models.role.one": "Role",
  "activerecord.models.status.one": "Status",
  "activerecord.models.status.other": "Statuses",
  "activerecord.models.user.one": "User",
  "activerecord.models.user.other": "Users",
  "automatic_updates.entry": "Entry",
  "automatic_updates.exit": "Exit",
  "automatic_updates.mixed": "Mixed",
  "automatic_updates.status_off": "Off - No status update",
  "badges.badge_reset": "Badge Reset",
  "badges.badge_reset_message": "If your badges or barcodes have been used inappropriately, you can destroy them all and generate new badges. By doing this, you immediately render all existing badges useless, so only do this if you are willing to immediately distribute new badges.",
  "badges.badges": "Badges",
  "badges.deleting_badges": "Deleting/Generating new badges will immediately render all existing badges unusable.",
  "badges.download_pdf": "Download PDF",
  "badges.generate_new": "Delete and Generate New Badges",
  "badges.please_wait_message": "This make take a few minutes. Please do not leave this page.",
  "badges.print_download": "Print/Download Badges",
  "beacons.entry_settings_subtitle": "When the phone can detect the Beacon",
  "beacons.exit_settings_subtitle": "When the phone can no longer detect the Beacon",
  "board.board": "Board",
  "board.columns": "Columns",
  "board.fullscreen": "Full Screen",
  "board.last_updated": "Last Updated",
  "board.no_future_updates": "No Status Updates are Scheduled",
  "board.no_status_updates": "No Status Updates in the Last Week",
  "board.optional_comment": "optional comment",
  "board.profile": "Profile",
  "board.reload": "Reload",
  "board.reload_all_statuses": "Reload all statuses",
  "board.search": "Search",
  "board.seven_day_history": "7 Day History",
  "board.sGroupZeroRecords": "Your search in the group \"%{group}\" didn\'t find any users",
  "board.sInfo": "Showing %{total} users",
  "board.sInfoPages": "Showing %{some} of %{total} users",
  "board.sUserEveryoneZeroRecords": "Your search for \"%{searchTerm}\" didn\'t find any users",
  "board.sUserGroupZeroRecords": "Your search for \"%{searchTerm}\" in the group \"%{group}\" didn\'t find any users",
  "board.text": "Text",
  "board.updating_status": "Updating Status",
  "board.user_information": "User Information",
  "board.user_is_in": "1 user is In",
  "board.users_are_in": "%{count} users are In",
  "credit_card.coupon_code": "Coupon Code",
  "credit_card.coupon_code_invalid": "The coupon code \'%{id}\' is not valid",
  "credit_card.coupon_code_valid": "Coupon \'%{id}\' applied for %{percent}% off for %{duration} months",
  "credit_card.number_and_security": "Number & Security",
  "credit_card.promotion": "Promotion",
  "credit_card.secure_credit": "Secure Credit Card Payment",
  "credit_card.stripe_html": "protected and encrypted by <a href=\'https://stripe.com/help/security\' class=\'alert-link\' target=\'_new\'>Stripe<\/a>",
  "credit_card.submitting": "Submitting",
  "credit_card.unable_to_secure": "Unable to Establish Secure Connection",
  "credit_card.unable_to_secure_html": "We could not establish a secure connection to our credit card provider. <a href=\'https://simpleinout.helpscoutdocs.com/article/258-why-wont-my-web-browser-allow-me-to-enter-a-credit-card-securely\' class=\'alert-link\' target=\'_new\'>Learn how to fix this issue in your browser<\/a>.",
  "credit_card.verifying_coupon": "Verifying Coupon Code",
  "credit_card.verifying_credit_card": "Verifying Credit Card",
  "date.one_letter_day_names": ["S", "M", "T", "W", "T", "F", "S"],
  "devise.failure.timeout": "Your session expired. Please sign in again to continue.",
  "edit_statuses.future_date_must_be_in_future": "Scheduled date must be in the future",
  "edit_statuses.future_title": "Schedule for %{name}",
  "edit_statuses.past_title": "Edit Statuses for %{name}",
  "fences.center_map": "Recenter Map",
  "fences.current_location": "Current Location",
  "fences.error_address_not_found": "Address not found",
  "fences.error_current_location_unavailable": "Location could not be determined. Please grant permission in your browser.",
  "fences.error_no_fence_location": "Please set the location of the Geofence on the map",
  "fences.list": "List",
  "fences.map": "Map",
  "fences.satellite": "Satellite",
  "fences.search_for_address": "Search for the address of your desired Geofence location",
  "fences.search_google_maps": "Search Google Maps",
  "fences.show_all": "Show All",
  "fences.small_radius_warning": "Larger Geofences are more reliable.",
  "fences.zoom_in": "Zoom In",
  "fences.zoom_out": "Zoom Out",
  "global.affirmative": "Yes",
  "global.all_data_will_be_destroyed": "All data will be destroyed permanently.",
  "global.are_you_sure": "Are you sure you wish to do this?",
  "global.ascending": "Ascending",
  "global.automatic": "Automatic",
  "global.cancel": "Cancel",
  "global.delete": "Delete",
  "global.deleted_user": "deleted user",
  "global.descending": "Descending",
  "global.description": "Description",
  "global.download": "Download",
  "global.edit": "Edit",
  "global.error": "An error occurred, please try again.",
  "global.error_csrf": "Your session expired. Please sign in again to continue.",
  "global.error_csrf_html": "Your session expired. Please sign in again to continue. <a href=\'javascript:window.location.reload(true);\' class=\'alert-link\'>Reload<\/a>",
  "global.error_disabled": "Your company has been disabled. Please contact your administrator.",
  "global.error_disabled_html": "Your company has been disabled. Please contact your administrator. <a href=\'javascript:window.location.reload(true);\' class=\'alert-link\'>Reload<\/a>",
  "global.error_forbidden": "Your permissions have changed and you are no longer authorized to perform this action.",
  "global.error_forbidden_html": "Your permissions have changed and you are no longer authorized to perform this action. <a href=\'javascript:window.location.reload(true);\' class=\'alert-link\'>Reload<\/a>",
  "global.everybody": "Everyone",
  "global.in": "In",
  "global.log_in": "Log In",
  "global.log_out": "Log Out",
  "global.negative": "No",
  "global.out": "Out",
  "global.remove": "Remove",
  "global.select_language": "Select your language",
  "global.selected_items": {"one":"1 selected","other":"%{count} selected"},
  "global.settings": "Settings",
  "global.sort": "Sort",
  "global.status": "Status",
  "global.subscribe": "Subscribe",
  "global.switch_off": "Off",
  "global.switch_on": "On",
  "global.unsubscribe": "Unsubscribe",
  "global.update": "Update",
  "global.upload": "Upload",
  "integrations.events_to_send": "Events to Send",
  "integrations.last_error_one": "The last request returned an error",
  "locales.en": "English (US)",
  "locales.en-au": "English (Australia)",
  "locales.en-ca": "English (Canada)",
  "locales.en-gb": "English (UK)",
  "locales.es": "Español",
  "locales.fr": "Français",
  "locales.fr-ca": "Français (Canada)",
  "mailing_list.unsubscribe_heading": "Unsubscribe Successful",
  "manager.archives.index.title": "Archived Users",
  "manager.future_warning": "Disabling the ability to schedule statuses will erase any statuses that were already scheduled. Make sure this is what you would like to do before clicking Save below.",
  "manager.learn_more": "Learn More",
  "manager.privileges": "Permissions",
  "manager.quick_picks_limit": "Quick Picks are limited to %{count} per company",
  "networks.entry_settings_subtitle": "When the phone connects to the Network",
  "networks.exit_settings_subtitle": "When the phone disconnects from the Network",
  "notifications.in": "in",
  "notifications.out": "out",
  "phrase.add_model": "Add %{model}",
  "phrase.by_user": "by %{name}",
  "phrase.create_model": "Create %{model}",
  "phrase.created": "%{model} created",
  "phrase.creating_model": "Creating %{model}",
  "phrase.delete_model": "Delete %{model}",
  "phrase.deleted": "%{model} deleted",
  "phrase.deleting_model": "Deleting %{model}",
  "phrase.edit_model": "Edit %{model}",
  "phrase.finding_model": "Finding %{model}",
  "phrase.hours_abbr": "%{hours}h",
  "phrase.loading_model": "Loading %{model}",
  "phrase.minutes_abbr": "%{minutes}m",
  "phrase.no_model": "No %{model}",
  "phrase.saving_model": "Saving %{model}",
  "phrase.settings": "%{model} Settings",
  "phrase.toggle_model": "Toggle %{model}",
  "phrase.update_model": "Update %{model}",
  "phrase.via": "via %{name}",
  "plan.change_credit_card": "Change Credit Card",
  "plan.change_subscription_plan": "Change Subscription Plan",
  "plan.credit_card_unknown_error": "There was a problem with your credit card and/or coupon code.",
  "plan.notifications": "Notifications",
  "plan.thank_you": "Thank You for Subscribing!",
  "public_links.hidden": "Hidden",
  "public_links.visible": "Visible",
  "reminders.after": "After",
  "reminders.at": "At",
  "reminders.remind_users": "Remind Users",
  "report.actions.archive": "archive",
  "report.actions.create": "create",
  "report.actions.destroy": "delete",
  "report.actions.transfer": "transfer",
  "report.actions.unarchive": "unarchive",
  "report.advanced_options": "Advanced Options",
  "report.contacts": "Contacts",
  "report.current_page": "Page %{current} of %{total}",
  "report.current_week": "Week %{current} of %{total}",
  "report.custom_column_label": "customize the last two columns",
  "report.date": "Date",
  "report.date_range": "Date Range",
  "report.day": "day",
  "report.details": "Details",
  "report.details_description": "Includes the details of every status update for the selected date range.",
  "report.details_grouped_by": "Details Grouped By",
  "report.document_started": "Document is now generating. Check below for the download status/link.",
  "report.error_no_audits": "No auditable actions were made during this time period",
  "report.error_too_long": "Sorry, an error occurred. Please make sure you\'ve chosen less than 31 days and try again.",
  "report.expires": "Expires %{time}",
  "report.filter_select_active_user": "U",
  "report.filter_select_archived_user": "A",
  "report.filter_select_group": "G",
  "report.filter_users": "Filter Users",
  "report.first": "First",
  "report.first_custom_column": "first custom column",
  "report.generating": "Generating...",
  "report.grand_total": "Grand Total",
  "report.groups_one": "1 group",
  "report.groups_other": "%{count} groups",
  "report.hours_in_workday": "Hours in a work day (progress bars)",
  "report.invalid_date_range": "The end date cannot be earlier than the start date",
  "report.last": "Last",
  "report.loading": "Loading...",
  "report.month": "month",
  "report.next": "Next",
  "report.no_archives": "No status updates were made during this time period",
  "report.no_results": "No results found.",
  "report.only_considered": "only these comments are considered",
  "report.previous": "Previous",
  "report.report_output": "Report Output",
  "report.run_at": "Run At",
  "report.run_report": "Run Report",
  "report.running_report": "Running Report",
  "report.search_placeholder_user": "Select a user",
  "report.search_placeholder_user_group": "Select multiple users and/or groups",
  "report.searching": "Searching...",
  "report.second_custom_column": "second custom column",
  "report.select_single_user": "Select a single user to run the report",
  "report.show": "show",
  "report.summary": "Summary",
  "report.summary+details": "Summary & Details",
  "report.summary_description_csv": "Includes the total minutes in or out for each day and the total minutes for the selected date range.",
  "report.summary_description_pdf": "Includes calendars, the total minutes in or out for each week, and the total minutes for the selected date range.",
  "report.summary_format": "Summary Format",
  "report.summary_format_labels": "Formatted Labels (Example: 8h 30m)",
  "report.summary_format_minutes": "Minutes",
  "report.time_zone": "Time Zone",
  "report.timeline": "Timeline",
  "report.to": "to",
  "report.today": "today",
  "report.total_these_statuses": "total these statuses",
  "report.type_to_search_user": "Start typing a user\'s name...",
  "report.type_to_search_user_group": "Start typing a user\'s name or a group\'s name...",
  "report.user_count_all": "Running for all users",
  "report.user_count_one": "Running for 1 user",
  "report.user_count_other": "Running for %{count} users",
  "report.users_all": "All users",
  "report.users_archived": "Archived User",
  "report.users_one": "1 user",
  "report.users_other": "%{count} users",
  "report.week": "week",
  "resets.description_html": "Users <strong>%{opposite_status}<\/strong> will be checked <strong>%{selected_status}<\/strong> at <strong>%{time}<\/strong> %{time_zone}",
  "roles.admin": "Administrator",
  "roles.admin_role": "Administrator Role",
  "roles.admin_role_info": "The administrator role is a special role and most permissions cannot be edited.",
  "roles.changes_warning": "Changes to an existing role will affect the assigned users.",
  "roles.current_statuses": "Current Statuses",
  "roles.default": "Default",
  "roles.enable_notification_permissions": "Upgrade to a Pro Plan to enable notification permissions.",
  "roles.enable_scheduled_statuses_permissions": "Turn on Scheduled Statuses to enable scheduled statuses permissions.",
  "roles.help.billing": "These users can change the company\'s plan, credit card, and invoice email/information.",
  "roles.help.followed_users": "These users can receive notifications on their devices when another user updates their status.",
  "roles.help.manage_groups_and_memberships": "These users can manage groups and which users are assigned to each group.",
  "roles.help.manage_others_archives": "These users can change the past statuses of others by adding and deleting status updates.",
  "roles.help.manage_others_futures": "These users can schedule future status updates for other users.",
  "roles.help.manage_others_status": "These users can change the current status of other users.",
  "roles.help.manage_own_archives": "These users can change their own past statuses by adding and deleting status updates.",
  "roles.help.manage_own_futures": "These users can schedule future status updates for themselves.",
  "roles.help.manage_own_status": "These users can update their own status from any device or the website. If a user is not allowed to update their own status, they can only update their status from a common device running FrontDesk or TimeClock.",
  "roles.help.reminders": "These users can manage notifications sent to other users reminding them to update their status.",
  "roles.help.safeties": "These users can receive notifications when another user hasn\'t updated their status.",
  "roles.help.user_board": "These users can see other users and their current status.",
  "roles.help.view_others_archives": "These users can view the past status updates made by other users.",
  "roles.help.view_others_futures": "These users can view the scheduled status updates for other users.",
  "roles.help.view_others_reports": "These users can run reports on the status history of other users.",
  "roles.help.view_user_board_updated_at": "These users can view the time that status updates were made on the board.",
  "roles.make_default": "Make this role the default for new users",
  "roles.reporting": "Reporting",
  "roles.required_for_view_others_reports": "Required to run reports on others",
  "roles.required_for_view_user_board_updated_at": "Required to view status update times",
  "roles.status_history": "Status History",
  "roles.this_is_default": "This is the default role for new users",
  "roles.toggle_all": "Toggle All",
  "roles.users_can": "Users in this role can:",
  "roles.users_cannot": "Users in this role cannot:",
  "stripe.card_declined": "The card was declined.",
  "stripe.expired_card": "The card has expired.",
  "stripe.incomplete_number": "Your card number is incomplete.",
  "stripe.incorrect_cvc": "The card\'s security code is incorrect.",
  "stripe.incorrect_number": "The card number is incorrect.",
  "stripe.incorrect_zip": "The card\'s zip code failed validation.",
  "stripe.invalid_cvc": "The card\'s security code is invalid.",
  "stripe.invalid_expiry_month": "The card\'s expiration month is invalid.",
  "stripe.invalid_expiry_month_past": "The card\'s expiration month is invalid.",
  "stripe.invalid_expiry_year": "The card\'s expiration year is invalid.",
  "stripe.invalid_expiry_year_past": "The card\'s expiration year is invalid.",
  "stripe.invalid_number": "The card number is not a valid credit card number.",
  "stripe.missing": "There is no card on a customer that is being charged.",
  "stripe.processing_error": "An error occurred while processing the card.",
  "teams.log_in": "Log in with Simple In/Out",
  "time.hour": {"one":"1 hour","other":"%{count} hours"}
};

global.i18n = i18n;
export default i18n;
